import * as Icons from "lucide-react";

// model = { recommendation, recToneCls, recIcon, whyBullets, nextAction, confidence, lowConfidence,
//           complexity, reviewedCount, reviewableCount, riskCount, missingCount, pendingCount,
//           serviceCount, isRejected, approving, rejecting }
// actions = { onNextAction, onApprove, onRerun, onReject }
export function ReviewCommandCard({ model, actions }) {
  const {
    recommendation, recToneCls, recIcon, whyBullets, nextAction, confidence, lowConfidence,
    isRejected, approving, rejecting,
  } = model;
  const RecIcon = Icons[recIcon] || Icons.Sparkles;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden" data-testid="ca-command-card">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-2.5">
        <span className="h-7 w-7 rounded-full bg-blue-50 flex items-center justify-center shrink-0"><Icons.Sparkles className="h-4 w-4 text-blue-600" /></span>
        <div>
          <div className="text-sm font-semibold text-slate-800">Allison's Recommendation</div>
          <div className="text-[11px] text-slate-400">Review summary</div>
        </div>
      </div>
      <div className="p-4 space-y-4">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-1.5">Status</div>
          <div className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm font-bold ${recToneCls}`} data-testid="ca-recommendation">
            <RecIcon className="h-4 w-4" />{recommendation}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-1">
            <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Confidence</div>
            <span className={`text-xs font-bold ${lowConfidence ? "text-amber-600" : "text-emerald-600"}`} data-testid="ca-confidence">{confidence}%</span>
          </div>
          <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
            <div className={`h-full transition-all ${lowConfidence ? "bg-amber-400" : "bg-emerald-500"}`} style={{ width: `${confidence || 0}%` }} />
          </div>
        </div>

        <div>
          <div className="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-1.5">Why</div>
          <ul className="space-y-1.5" data-testid="ca-why">
            {whyBullets.map((b, i) => (
              <li key={i} className="flex gap-2 text-xs text-slate-600"><Icons.Dot className="h-4 w-4 text-slate-300 shrink-0 -ml-1" /><span>{b}</span></li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg bg-blue-50 border border-blue-100 px-3 py-2" data-testid="ca-next-action">
          <div className="text-[10px] font-bold uppercase tracking-wider text-blue-500 mb-0.5">Next Step</div>
          <button onClick={actions.onNextAction}
            className="text-sm font-semibold text-blue-800 hover:text-blue-900 flex items-center gap-1">
            {nextAction}<Icons.ArrowRight className="h-3.5 w-3.5" />
          </button>
        </div>

        <div className="pt-1 space-y-2 border-t border-slate-100">
          {isRejected ? (
            <button onClick={actions.onRerun} data-testid="ca-card-reanalyze"
              className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg px-4 py-2.5 text-sm">
              <Icons.Sparkles className="h-4 w-4" />Ask Allison to Re-analyze
            </button>
          ) : (
            <>
              <button onClick={actions.onApprove} disabled={approving || rejecting} data-testid="ca-approve"
                className="w-full inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg px-4 py-2.5 text-sm disabled:opacity-50">
                {approving ? <Icons.Loader2 className="h-4 w-4 animate-spin" /> : <Icons.CheckCircle2 className="h-4 w-4" />}Approve Estimate
              </button>
              <div className="flex items-center gap-2">
                <button onClick={actions.onRerun} disabled={approving || rejecting} data-testid="ca-rerun"
                  className="flex-1 inline-flex items-center justify-center gap-1.5 border border-blue-200 text-blue-700 hover:bg-blue-50 font-semibold rounded-lg px-3 py-2 text-xs disabled:opacity-50">
                  <Icons.RefreshCw className="h-3.5 w-3.5" />Re-run
                </button>
                <button onClick={actions.onReject} disabled={rejecting || approving} data-testid="ca-reject"
                  className="flex-1 inline-flex items-center justify-center gap-1.5 border border-rose-200 text-rose-700 hover:bg-rose-50 font-semibold rounded-lg px-3 py-2 text-xs disabled:opacity-50">
                  {rejecting ? <Icons.Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Icons.XCircle className="h-3.5 w-3.5" />}Reject
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
